import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';
import {
    Avatar,
    Container,
    Icon,
    Info,
    Status
} from './styled';
import {
    MaterialIcon,
    Text
} from 'mol-ui';

const ProfessionalItem = ({
    avatar,
    color,
    icon,
    status,
    text,
    title,
    redirect
}) => {

    const { textColor } = useTheme();
    
    return (
        <Container onClick={ redirect }>
            <Info>
                <Icon color={ color }>
                    {
                        avatar
                            ? <Avatar src={ avatar } />
                            : <MaterialIcon color={ textColor } icon={ icon } size={ 35 } />
                    }
                </Icon>
                <div>
                    <Text fontSize="14px" margin="0px 0px 3px 0px">{ title }</Text>
                    <Text fontSize="10px" margin="0px 0px 3px 0px">{ text }</Text>
                    { status && <Status status={ status }>{ status }</Status> }
                </div>
            </Info>
        </Container>
    );
};

ProfessionalItem.propTypes = {
    avatar: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.string,
    redirect: PropTypes.func,
    status: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string
};

export default ProfessionalItem;
